var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.875 9.375H6.03125V12.2672L4.81719 11.0578L4.15625 11.7188L6.5 14.0625L8.84375 11.7188L8.18281 11.0578L6.96875 12.2672V9.375H12.125V8.4375H0.875V9.375ZM4.15625 3.28125L4.81719 3.94219L6.03125 2.73281V5.625H0.875V6.5625H12.125V5.625H6.96875V2.73281L8.18281 3.94219L8.84375 3.28125L6.5 0.9375L4.15625 3.28125Z",
    fill: "#454545"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.3e34256c33a5a0d6dd6a39dbac77fb0c.svg";
export { ForwardRef as ReactComponent };